import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled(({ videoThumbnail, ...otherProps }) => (
  <div {...otherProps} />
))`
  && {
    height: 85px;
    width: 151px;
    background-color: #000000;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    background-image: url(${(props) => props.videoThumbnail});
    background-position: center;
    background-size: cover;
    margin: 0 auto;
  }
`;

const StyledOverLayDiv = styled.div`
  height: 100%;
  width: 100%;
  background-color: black;
  opacity: 0.6;
  border-radius: 8px;
`;

const StyledPlayButton = styled.img`
  && {
    position: absolute;
    right: 59px;
    top: 30px;
  }
`;

const StyledIframe = styled.iframe`
  && {
    border-radius: 8px;
    width: 835px;
    height: 470px;
    @media (max-width: 768px) {
      width: 350px;
      height: 250px;
    }
  }
`;

export { StyledDiv, StyledOverLayDiv, StyledPlayButton, StyledIframe };
